import React, { useState, useEffect, useRef,useMemo  } from "react";
import {
  useReactTable,
  getCoreRowModel,
  getSortedRowModel,
  getFilteredRowModel,
  flexRender,
  getPaginationRowModel,
} from "@tanstack/react-table";
import { FileDown, Network } from "lucide-react"; // ✅ professional icons
import { useLocation, useNavigate } from "react-router-dom";
import axiosClient from "../../../../api-client/AxiosClient";
import Spinner from "../../../common/Spinner/Spinner";
import Select from "react-select";
import { toast } from "react-toastify";
import logo from "../../../../assets/chatbot.png";
import { validateCorporationData } from "../../../../utils/dataValidation";
import { Database } from "lucide-react";
import network from "../../../../assets/network1.png";
import history from "../../../../assets/download2.png";
import download from "../../../../assets/download3.png";

import {
  processJsonData,
  globalFilterFn,
  calculateTableHeight,
  handleColumnResizeStart as resizeColumn,
} from "./TableUtils";
import "./HistoryData.css";
import { ChevronDown } from "lucide-react";
import { Bot } from "lucide-react"; // 👈 Import Bot icon
import ChatbotPopup from "./ChatbotPopup";
import FalconAIChatbot from "./FalconAIChatbot";
import { X } from "lucide-react";
import chatbot from "../../../../assets/chatbot.png";
import StickyNotesPopup from "./StickyNotesPopup";
import DataLineageDashboard from "../DataLineage/datalineage";
import DataLineageViewer from "../DataLineage/erd";
import DataLineageViewers from "../DataLineage/objectOrientedDataLineage";

const getFilteredData = (data, showInscopeOnly, showMandatoryOnly) => {
  let filteredData = [...data];
  
  if (showInscopeOnly) {
    filteredData = filteredData.filter(
      row => row.inscope === "Y" || row["In-scope"] === "Y"
    );
  }
  
  if (showMandatoryOnly) {
    filteredData = filteredData.filter(
      row => row.mandatoryfeild === "Y" || row["Mandatory Field (S4)"] === "Y"
    );
  }
  
  return filteredData;
};


const CreateTable = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { STTMapping } = JSON.parse(
    sessionStorage.getItem("rolesAndPermission") || "{}"
  );
  const { canUpdate } = STTMapping;
  const [showInscopeOnly, setShowInscopeOnly] = useState(false);
  const [showMandatoryOnly, setShowMandatoryOnly] = useState(false);
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [sorting, setSorting] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [dependentValues, setDependentValues] = useState({});
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const [columnFilters, setColumnFilters] = useState([]);
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 15 });
  const [localValue, setLocalValue] = useState({});
  const [loading, setLoading] = useState(false);
  const [dropdownValue, setDropdownValue] = useState(null);
  const [uploadedFileList, setUploadedFileList] = useState([]);
  const [selectedCorporation, setSelectedCorporation] = useState(null);
  const [allFiles, setAllFiles] = useState([]); // Store all files from API
  const [showAIAgent, setShowAIAgent] = useState(false);
  const [panelWidth, setPanelWidth] = useState(800); // Default width
  const [isResizingPanel, setIsResizingPanel] = useState(false);
  const [error, setError] = useState(null); // ✅ Add error state
  const [showReverseEngineering, setShowReverseEngineering] = useState(false);
  const [activePanel, setActivePanel] = useState(null); // 'ai' or 'erd'
  const [stickyNotePopup, setStickyNotePopup] = useState({
    isOpen: false,
    value: "",
    rowIndex: null,
    columnId: null,
  });

  const filteredData = useMemo(() => {
    return getFilteredData(data, showInscopeOnly, showMandatoryOnly);
  }, [data, showInscopeOnly, showMandatoryOnly]);

  const panelRef = useRef(null);
  const resizerRef = useRef(null);

  const isMountedRef = useRef(false);
  const [pageData, setPageData] = useState({
    fileID: location.state?.fileID || null,
  });
  const [sourceTableColumnName, setSourceTableColumnName] = useState(null);
  const [fieldTypeMap, setFieldTypeMap] = useState(new Map());
  const [resizingColumn, setResizingColumn] = useState(null);
  const [columnSizes, setColumnSizes] = useState({});
  const [columnVisibilityMenu, setColumnVisibilityMenu] = useState(false);
  const [columnVisibility, setColumnVisibility] = useState({
    usermappingfiledetailsid: false,
    usermappingfileid: false,
    templateid: false,
    isactive: false,
  });
  // By default, all 3 columns are visible (checkboxes unchecked)
  const [hideColumnsData, setHideColumnsData] = useState([]); // [] means all visible
  const [resizingRow, setResizingRow] = useState(null);
  const [rowSizes, setRowSizes] = useState({});
  const [rowPinning, setRowPinning] = useState({ top: [] });
  const [rowSelection, setRowSelection] = useState({});
  const [frozenColumns, setFrozenColumns] = useState(new Set());
  // State for group dropdown
  const [showGroupDropdown, setShowGroupDropdown] = useState(false);

  const containerRef = useRef(null);
  const visibilityButtonRef = useRef(null);
  const dropdownRef = useRef(null);
//added fetch all files
  const fetchAllFiles = async (corporationId) => {
    if (!corporationId) {
      setUploadedFileList([]);
      setData([]);
      setColumns([]);
      setDropdownValue(null);
      setAllFiles([]);
      return;
    }

    setLoading(true);

    try {
      const filesResponse = await axiosClient.get(
        `/api/Mapper/GetMapperFiles/${corporationId}`
      );

      const formattedFiles = filesResponse.data.map((item) => ({
        value: item.userMappingFileId,
        label: item.uploadedObjDescription,
        id: item?.corporationId,
      }));

      setAllFiles(filesResponse.data);
      setUploadedFileList(formattedFiles);

      // Auto-select first file if no file is currently selected
      
      if (pageData.fileID) {
        const selectedFile = formattedFiles.find(
          (opt) => opt.value === pageData.fileID
        );
        if (selectedFile) {
          setDropdownValue(selectedFile);
        } else {
          setDropdownValue(formattedFiles.length > 0 ? formattedFiles[0] : null);
        }
      } else if (formattedFiles.length > 0) {
        setDropdownValue(formattedFiles[0]);
      }
    } catch (error) {
      toast.error("Failed to fetch file list");
    } finally {
      setLoading(false);
    }
  };

  //  LOAD CORPORATION FROM localStorage (ONCE ON MOUNT)
  useEffect(() => {
    try {
      const storedCorporation = localStorage.getItem("selectedCorporation");
      if (storedCorporation) {
        const parsedCorporation = JSON.parse(storedCorporation);
        const validatedCorp = validateCorporationData(parsedCorporation);
        setSelectedCorporation(validatedCorp);
       const storedFileData = sessionStorage.getItem("selectedFileData");
      if (storedFileData) {
        const parsedFileData = JSON.parse(storedFileData);
        if (parsedFileData.corporationId === validatedCorp?.value) {
          setPageData(prev => ({ ...prev, fileID: parsedFileData.fileID }));
        }
      }
    }
  } catch (error) {
    setError("Failed to load corporation data");
    localStorage.removeItem("selectedCorporation");
  }
}, []);
  //  LISTEN FOR STORAGE CHANGES (FETCH IMMEDIATELY)

  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === "selectedCorporation") {
        try {
          if (e.newValue === null) {
            setSelectedCorporation(null);
            setUploadedFileList([]);
            setData([]);
            setColumns([]);
            setDropdownValue(null);
            setAllFiles([]);
            return;
          }

          const parsedData = JSON.parse(e.newValue);
          const validatedCorp = validateCorporationData(parsedData);
          setSelectedCorporation(validatedCorp);

          //  IMMEDIATELY fetch data for new corporation
          if (validatedCorp?.value) {
            setData([]);
            setColumns([]);
            setDropdownValue(null);
            fetchAllFiles(validatedCorp.value);
          }
        } catch (error) {
          
          setError("Invalid corporation data");
          localStorage.removeItem("selectedCorporation");
        }
      }
    };

    const handleCustomStorageChange = (e) => {
      if (e.detail?.key === "selectedCorporation") {
        try {
          if (e.detail.newValue === null || e.detail.newValue === undefined) {
            setSelectedCorporation(null);
            setUploadedFileList([]);
            setData([]);
            setColumns([]);
            setDropdownValue(null);
            setAllFiles([]);
            return;
          }

          //  Match the working pattern from DataSource.js
          const newCorporation = e.detail.newValue
            ? validateCorporationData(
                typeof e.detail.newValue === 'string' 
                  ? JSON.parse(e.detail.newValue)
                  : e.detail.newValue
              )
            : null;

          setSelectedCorporation(newCorporation);

          //  IMMEDIATELY fetch data for new corporation
          if (newCorporation?.value) {
            setData([]);
            setColumns([]);
            setDropdownValue(null);
            fetchAllFiles(newCorporation.value);
          }
        } catch (error) {
          
          setError("Invalid corporation data");
        }
      }
    };
    window.addEventListener("storage", handleStorageChange);
    window.addEventListener("customStorageChange", handleCustomStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("customStorageChange", handleCustomStorageChange);
    };
  }, []);

  
  //  FETCH WHEN CORPORATION CHANGES (BACKUP TRIGGER)
 
  useEffect(() => {
    if (selectedCorporation?.value) {
      
      fetchAllFiles(selectedCorporation.value);
    } else {
      setUploadedFileList([]);
      setData([]);
      setColumns([]);
      setDropdownValue(null);
      setAllFiles([]);
    }
  }, [selectedCorporation]);

  useEffect(() => {
    const handleGetFilters = async () => {
      const response = await axiosClient.get("/api/Mapper/GetFilters");

      setHideColumnsData([...response.data.hideColumnsData]);
      setShowInscopeOnly(response.data.showInscopeOnly);
      setShowMandatoryOnly(response.data.showMandatoryOnly);
      setGlobalFilter(response.data.globalFilter);
      setDropdownValue(response.data.dropdownValue);
      setColumnVisibility(response.data.columnVisibility);
    };

    handleGetFilters();
  }, []);

  useEffect(() => {
    const payload = {
      hideColumnsData,
      showInscopeOnly,
      showMandatoryOnly,
      globalFilter,
      dropdownValue: dropdownValue || {},
      columnVisibility,
    };

    const handleApiSubmit = async () => {
      try {
        await axiosClient.post("/api/Mapper/SaveFilters", payload);
      } catch (error) {
        console.error("Unexpected Error:", error);
      }
    };

    handleApiSubmit();
  }, [
    hideColumnsData,
    showInscopeOnly,
    showMandatoryOnly,
    globalFilter,
    dropdownValue,
    columnVisibility,
  ]);

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (!isResizingPanel) return;

      // Calculate new width (RTL - right side resize)
      const container = containerRef.current;
      if (container) {
        const containerRect = container.getBoundingClientRect();
        const newWidth = containerRect.right - e.clientX;

        // Min width: 300px, Max width: 70% of container
        const minWidth = 300;
        const maxWidth = Math.floor(containerRect.width * 0.7);

        const constrainedWidth = Math.max(
          minWidth,
          Math.min(newWidth, maxWidth)
        );
        setPanelWidth(constrainedWidth);
      }
    };

    const handleMouseUp = () => {
      setIsResizingPanel(false);
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };

    if (isResizingPanel) {
      document.addEventListener("mousemove", handleMouseMove);
      document.addEventListener("mouseup", handleMouseUp);
    }

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };
  }, [isResizingPanel]);

  // Map typeOfColumns to their columncategoryname in the table
  // (already declared below, remove this duplicate)
  // Helper to get all column ids for a given category name
  const getColumnIdsByCategory = (category) =>
    table
      .getAllLeafColumns()
      .filter(
        (col) =>
          col.columnDef?.columncategoryname?.toLowerCase() ===
          category.toLowerCase()
      )
      .map((col) => col.id);

  // Sync hideColumnsData and columnVisibility
  // When user toggles a hide column, update both hideColumnsData and columnVisibility
  const handleHideColumnsData = (columnToHide) => {
    setHideColumnsData((prev) => {
      let newHideColumns;
      if (prev.includes(columnToHide)) {
        // Unchecking: remove from hideColumnsData (show column)
        newHideColumns = prev.filter((col) => col !== columnToHide);
      } else {
        // Checking: add to hideColumnsData (hide column)
        newHideColumns = [...prev, columnToHide];
      }
      // Update columnVisibility state for all columns in this category
      const affectedColumnIds = getColumnIdsByCategory(columnToHide);
      setColumnVisibility((old) => {
        const updated = { ...old };
        affectedColumnIds.forEach((id) => {
          // If the category is being hidden (checkbox checked), set all to false (hidden)
          // If the category is being shown (checkbox unchecked), set all to true (visible)
          updated[id] = prev.includes(columnToHide) ? true : false;
        });
        return updated;
      });
      return newHideColumns;
    });
  };

  // When a column is made visible in the dropdown, uncheck the group hide checkbox for that category
  useEffect(() => {
    // For each typeOfColumns group, if any column in that group is visible, remove it from hideColumnsData
    typeOfColumns.forEach((group) => {
      const groupKey = group.toLowerCase();
      const groupColumnIds = getColumnIdsByCategory(groupKey);
      const anyVisible = groupColumnIds.some((id) => {
        // If columnVisibility[id] is true or undefined (default visible)
        return columnVisibility[id] !== false;
      });
      if (anyVisible && hideColumnsData.includes(groupKey)) {
        setHideColumnsData((prev) => prev.filter((col) => col !== groupKey));
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [columnVisibility]);

  // Handle checkbox value updates
  const updateCheckboxValue = async (row, columnId, checked) => {
    try {
      setLoading(true); // Show loader
      const value = checked ? "Y" : "N";
      const updatedRow = { ...row.original, [columnId]: value };

      let updateRequest = {
        userMappingFileDetailsId: updatedRow.usermappingfiledetailsid,
        inscope: updatedRow.inscope || "N",
        mandatoryfeild: updatedRow.mandatoryfeild || "N",
      };

      // Add fields from fieldTypeMap
      fieldTypeMap.forEach((fieldConfig, excelColumnName) => {
        if (
          fieldConfig.dbColumnName &&
          updatedRow[excelColumnName] !== undefined
        ) {
          let value = updatedRow[excelColumnName];

          // Convert checkbox values
          if (fieldConfig.editType === "checkbox") {
            value = value === true || value === "Y" ? "Y" : "N";
          } else {
            value = value === null || value === undefined ? "" : String(value);
          }

          updateRequest[fieldConfig.dbColumnName] = value;
        }
      });

      setData((prevData) => {
        const newData = [...prevData];
        newData[row.index] = updatedRow;
        return newData;
      });

      updateRequest = {
        userMappingFileId: pageData.fileID,
        updateMapperDetailsRequests: [updateRequest],
      };

      // Call API with proper payload
      const response = await axiosClient.post(
        "/api/Mapper/UpdateMapperFile",
        updateRequest
      );

      if (response.status === 200) {
        toast.success("Checkbox updated successfully");
      }
    } catch (error) {
      // Revert on error
      setData((prevData) => {
        const newData = [...prevData];
        newData[row.index] = row.original;
        return newData;
      });
      toast.error("Failed to update checkbox value");
    } finally {
      setLoading(false); // Hide loader
    }
  };

  const handleColumnResizeStart = (e, header) => {
    resizeColumn(e, header, setResizingColumn, columnSizes, setColumnSizes);
  };
  

  // Load dependent values for existing table selections when data is loaded
  useEffect(() => {
    if (data.length > 0 && sourceTableColumnName) {
      // Get all unique table names that are already selected in the data
      const existingTableNames = data
        .map((row) => row[sourceTableColumnName])
        .filter((tableName) => tableName && tableName.trim() !== "")
        .filter((tableName, index, arr) => arr.indexOf(tableName) === index); // Remove duplicates

      // Fetch dependent values for each existing table name
      existingTableNames.forEach((tableName) => {
        if (!dependentValues[tableName]) {
          fetchDependentValues(tableName);
        }
      });
    }
  }, [data, sourceTableColumnName]); // Dependencies: data and sourceTableColumnName

  // Load dependent values for pre-existing table selections after data is processed
  useEffect(() => {
    if (
      data.length > 0 &&
      sourceTableColumnName &&
      dropdownOptions.length > 0
    ) {
      const existingTableNames = data
        .map((row) => row[sourceTableColumnName])
        .filter((tableName) => tableName && tableName.trim() !== "")
        .filter((tableName, index, arr) => arr.indexOf(tableName) === index);

      existingTableNames.forEach((tableName) => {
        if (!dependentValues[tableName]) {
          fetchDependentValues(tableName);
        }
      });
    }
  }, [data, sourceTableColumnName, dropdownOptions]);

  

  const handleRowResizeStart = (e, rowId) => {
    e.preventDefault();
    setResizingRow(rowId);

    const startY = e.pageY;
    const startHeight = rowSizes[rowId] || 36; // Default row height is 36px

    const handleMouseMove = (e) => {
      const newHeight = Math.max(startHeight + (e.pageY - startY), 24); // Minimum height: 24px
      setRowSizes((prev) => ({ ...prev, [rowId]: newHeight }));
    };

    const handleMouseUp = () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
      setResizingRow(null);
    };

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };
  const toggleColumnFreeze = (columnId) => {
    setFrozenColumns((prev) => {
      const newFrozen = new Set(prev);
      if (newFrozen.has(columnId)) {
        newFrozen.delete(columnId);
      } else {
        newFrozen.add(columnId);
      }
      return newFrozen;
    });

    // Force a re-render to ensure all cells get updated styles
    setTimeout(() => {
      setData((prevData) => [...prevData]);
    }, 0);
  };

  const areAllColumnsSelected = () => {
    const hiddenSystemColumns = [
      "usermappingfiledetailsid",
      "usermappingfileid",
      "templateid",
      "isactive",
    ];

    return table
      .getAllLeafColumns()
      .filter((column) => !hiddenSystemColumns.includes(column.id))
      .every((column) => column.getIsVisible());
  };

   useEffect(() => {
    setPagination(prev => ({ ...prev, pageIndex: 0 }));
  }, [showInscopeOnly, showMandatoryOnly]);

  const table = useReactTable({
    data :filteredData,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    globalFilterFn,
    state: {
      sorting,
      globalFilter,
      columnFilters,
      pagination,
      columnVisibility,
      // expanded,
      rowPinning,
      rowSelection, // Add this
    },
    onSortingChange: setSorting,
    onGlobalFilterChange: setGlobalFilter,
    onColumnFiltersChange: setColumnFilters,
    onColumnVisibilityChange: setColumnVisibility,
    onPaginationChange: setPagination,
    // onExpandedChange: setExpanded,
    onRowPinningChange: setRowPinning,
    onRowSelectionChange: setRowSelection, // Add this
    autoResetPageIndex: false,
    defaultColumn: { size: 120 },
    enableRowPinning: true,
    // enableExpanding: true,
    enableRowSelection: true, // Add this
  });

  // Toggle column visibility menu
  const toggleColumnVisibilityMenu = () => {
    setColumnVisibilityMenu(!columnVisibilityMenu);
  };

  const selectAllColumns = () => {
    const hiddenSystemColumns = [
      "usermappingfiledetailsid",
      "usermappingfileid",
      "templateid",
      "isactive",
    ];

    const newVisibility = {};
    table.getAllLeafColumns().forEach((column) => {
      newVisibility[column.id] = !hiddenSystemColumns.includes(column.id);
    });

    setColumnVisibility(newVisibility);
    // Uncheck all hide columns (show all)
    setHideColumnsData([]);
  };

  const unselectAllColumns = () => {
    const newVisibility = {};
    table.getAllLeafColumns().forEach((column) => {
      newVisibility[column.id] = false;
    });

    setColumnVisibility(newVisibility);
    // Check all hide columns (hide all)
    setHideColumnsData(typeOfColumns.map((col) => col.toLowerCase()));
  };

  // Handle clicks outside visibility menu
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        visibilityButtonRef.current &&
        !visibilityButtonRef.current.contains(event.target)
      ) {
        setColumnVisibilityMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowGroupDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Utility to convert array of objects to CSV string
  const convertToCSV = (arr) => {
    if (!arr || arr.length === 0) return "";
    const keys = Object.keys(arr[0]);
    const csvRows = [
      keys.join(","), // header row
      ...arr.map((row) =>
        keys
          .map((k) => `"${(row[k] ?? "").toString().replace(/"/g, '""')}"`)
          .join(",")
      ),
    ];
    return csvRows.join("\r\n");
  };

  // Utility to trigger download of CSV file
  const downloadCSV = (csv, filename = "mapping_data.csv") => {
    const blob = new Blob([csv], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  };

  // Fetch mapping data by Excel ID
  const fetchMappingDataByExcelID = async (fileID, exportCSV = false) => {
    // In the fetchMappingDataByExcelID function
    const processData = (data) => {
      return data.map((row) => ({
        ...row,
        // Normalize checkbox values
        "In-scope": row["In-scope"]
          ? ["Y", "y", "Yes", "TRUE", "true", 1, "1"].includes(row["In-scope"])
            ? "Y"
            : "N"
          : "N",
        "Mandatory Field (S4)": row["Mandatory Field (S4)"]
          ? ["Y", "y", "Yes", "TRUE", "true", 1, "1"].includes(
              row["Mandatory Field (S4)"]
            )
            ? "Y"
            : "N"
          : "N",
      }));
    };

    try {
      setLoading(true);
      setPagination({ pageIndex: 0, pageSize: 15 });

      const [tablesResponse, templateResponse, mapperResponse] =
        await Promise.all([
          axiosClient.get("/api/Mapper/GetAvailbleTables", {
            params: { UserMappingFileId: fileID },
          }),
          axiosClient.get(
            "/api/Mapper/GetTemplateDetailsByUploadFile?userMappingFileId=" +
              fileID
          ),
          axiosClient.get(
            "/api/Mapper/GetMapperFileDetails?userMappingFileId=" + fileID
          ),
        ]);

      // Process the data before passing it to processJsonData
      const normalizedData = processData(mapperResponse.data);

      // Export CSV if requested
      if (exportCSV) {
        const csv = convertToCSV(normalizedData);
        downloadCSV(csv, `mapping_data_${fileID}.csv`);
        setLoading(false);
        return;
      }
      processJsonData(
        normalizedData,
        tablesResponse.data,
        templateResponse.data,
        setColumns,
        setData,
        setFieldTypeMap,
        setDropdownOptions,
        setSourceTableColumnName,
        updateRow
      );
    } catch (error) {
      toast.error(
        "Error fetching mapping data: " + (error.message || "Unknown error")
      );
    } finally {
      setLoading(false);
    }
  };

  

  useEffect(() => {
    if (dropdownValue) {
      setPageData((prev) => ({ ...prev, fileID: dropdownValue.value }));
      fetchMappingDataByExcelID(dropdownValue.value);

      // Store both fileID and file name in sessionStorage
      sessionStorage.setItem("selectedFileId", dropdownValue.value);
      sessionStorage.setItem("selectedFileName", dropdownValue.label);

      // Store the entire file object as JSON
      sessionStorage.setItem(
        "selectedFileData",
        JSON.stringify({
          fileID: dropdownValue.value,
          fileName: dropdownValue.label,
          corporationId: dropdownValue.id,
        })
      );

      // ✅ NEW: Dispatch custom event for same-window synchronization
      window.dispatchEvent(
        new CustomEvent("customStorageChange", {
          detail: {
            key: "selectedFileId",
            newValue: dropdownValue.value,
          },
        })
      );
    }
  }, [dropdownValue]);
  // Update row data
  const updateRow = async (row, columnHeader, updatedValue, fieldName) => {
    const normalizedValue = updatedValue === undefined ? "" : updatedValue;
    if (row.original[columnHeader] === updatedValue) return;
    let updatedRow = { ...row.original, [columnHeader]: normalizedValue };

    // Handle source table name change
    if (fieldName === "STN") {
      await fetchDependentValues(updatedValue);
      fieldTypeMap.forEach((fieldConfig) => {
        if (
          fieldConfig.dbColumnName === "sourcefieldname" ||
          fieldConfig.dbColumnName === "sourcedatatype"
        ) {
          updatedRow[fieldConfig.excelColumnName] = "";
        }
      });
    }
    // Handle source field name change
    else if (fieldName === "SFN") {
      const selectedColumn = dependentValues[
        row.original[sourceTableColumnName]
      ]?.find((col) => col.columnName === updatedValue);

      if (selectedColumn) {
        fieldTypeMap.forEach((fieldConfig) => {
          // Update data type column
          if (fieldConfig.dbColumnName === "sourcedatatype") {
            updatedRow[fieldConfig.excelColumnName] =
              selectedColumn.columnDataType;
          }

          // Update data length column
          if (fieldConfig.dbColumnName === "sourcedatalength") {
            // Priority: columnDataCharLength first, then columnPrecision
            let dataLength = "";
            if (selectedColumn.columnDataCharLength) {
              dataLength = selectedColumn.columnDataCharLength;
            } else if (selectedColumn.columnPrecision) {
              dataLength = selectedColumn.columnPrecision;
            }
            updatedRow[fieldConfig.excelColumnName] = dataLength;
          }
        });
      }
    }

    // Update UI optimistically
    setData((prevData) => {
      const newData = [...prevData];
      newData[row.index] = updatedRow;
      return newData;
    });

    // Call API
    try {
      await updateData(updatedRow);

      // Clear local value state
      setLocalValue((prev) => {
        const updated = { ...prev };
        delete updated[`${row.index}-${columnHeader}`];
        return updated;
      });
    } catch (error) {
      // Revert on error
      setData((prevData) => {
        const newData = [...prevData];
        newData[row.index] = row.original;
        return newData;
      });
      toast.error("Update failed");
    }
  };

  // Update data on the server
  const updateData = async (rowData) => {
    try {
      setLoading(true);

      const updateRequest = {
        userMappingFileDetailsId: rowData.usermappingfiledetailsid,
        inscope: rowData.inscope || "N",
        mandatoryfeild: rowData.mandatoryfeild || "N",
      };

      // Add the newly enabled editable columns
      if (rowData.comments !== undefined) {
        updateRequest.comments = rowData.comments || "";
      }
      if (rowData["datacleansingconsiderations"] !== undefined) {
        updateRequest.comments = rowData["datacleansingconsiderations"] || ""; // Adjust field name as needed
      }
      if (rowData["sourcefielddescription"] !== undefined) {
        updateRequest.sourcefielddescription =
          rowData["sourcefielddescription"] || "";
      }
      if (rowData["viewfieldname"] !== undefined) {
        updateRequest.viewfieldname = rowData["viewfieldname"] || "";
      }

      // Add fields from fieldTypeMap
      fieldTypeMap.forEach((fieldConfig, excelColumnName) => {
        if (
          fieldConfig.dbColumnName &&
          rowData[excelColumnName] !== undefined
        ) {
          let value = rowData[excelColumnName];

          // Convert checkbox values
          if (fieldConfig.editType === "checkbox") {
            value = value === true || value === "Y" ? "Y" : "N";
          } else {
            value = value === null || value === undefined ? "" : String(value);
          }

          updateRequest[fieldConfig.dbColumnName] = value;
        }
      });

      const response = await axiosClient.post("/api/Mapper/UpdateMapperFile", {
        userMappingFileId: pageData.fileID,
        updateMapperDetailsRequests: [updateRequest],
      });

      if (response.status === 200) {
        toast.success("Updated successfully");
      }
    } catch (error) {
      toast.error("Failed to update: " + (error.message || "Unknown error"));
      throw error;
    } finally {
      setLoading(false);
    }
  };

  // Fetch dependent values (column options)
  // Fetch dependent values (column options)
  // Fetch dependent values (column options)
  const fetchDependentValues = async (value) => {
    // Don't make API call if value is empty/null/undefined
    if (!value || value.trim() === "") {
      return;
    }

    // Don't fetch if we already have the data
    if (dependentValues[value] && dependentValues[value].length > 0) {
      return;
    }

    try {
      setLoading(true);
      const response = await axiosClient.get(
        "/api/Mapper/GetAvailbleTableColumns",
        {
          params: { TableName: value, UserMappingFileId: pageData.fileID },
        }
      );
      setDependentValues((prev) => ({ ...prev, [value]: response.data }));
    } catch (error) {
      toast.error("Failed to fetch dependent data");
    } finally {
      setLoading(false);
    }
  };

  // Handle page size change
  const handlePageSizeChange = (event) => {
    const newSize = Number(event.target.value);
    setPagination((prev) => {
      const newPageIndex = Math.floor(
        (prev.pageIndex * prev.pageSize) / newSize
      );
      return { pageSize: newSize, pageIndex: newPageIndex };
    });
    table.setPageSize(newSize);
  };

  // Custom select styles
  const customSelectStyles = {
    control: (provided) => ({ ...provided, minHeight: "28px", height: "28px" }),
    valueContainer: (provided) => ({
      ...provided,
      height: "28px",
      padding: "0 6px",
    }),
    input: (provided) => ({ ...provided, margin: "0px" }),
    indicatorsContainer: (provided) => ({ ...provided, height: "28px" }),
    dropdownIndicator: (provided) => ({ ...provided, padding: "4px" }),
    clearIndicator: (provided) => ({ ...provided, padding: "4px" }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }), // ✅ CHANGE THIS - was 2, now 9999
  };

  const renderCellContent = (cell, row, columnDef) => {
    // ✅ NEW: Check if this is the Transformation Rule column
    if (
      cell.column.id.toLowerCase().includes("transformation") ||
      columnDef.fieldName === "TransformationRule"
    ) {
      return (
        <div
          onClick={(e) => {
            e.stopPropagation();
            const rect = e.currentTarget.getBoundingClientRect();

            // For position: fixed, use viewport coordinates directly (no scroll offset needed)
            setStickyNotePopup({
              isOpen: true,
              value: cell.getValue() || "",
              rowIndex: row.index,
              columnId: cell.column.id,
              position: {
                top: rect.bottom + 8, // ✅ Correct - viewport coordinates only
                left: rect.left, // ✅ Correct - viewport coordinates only
              },
            });
          }}
          style={{
            cursor: "pointer",
            padding: "4px 8px",
            minHeight: "24px",
            display: "flex",
            alignItems: "center",
            color: cell.getValue() ? "#1f2937" : "#9ca3af",
            backgroundColor: "transparent",
            transition: "background-color 0.2s",
            borderRadius: "4px",
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.backgroundColor = "#f3f4f6";
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.backgroundColor = "transparent";
          }}
          title="Click to edit in sticky notes"
        >
          <span
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              flex: 1,
            }}
          >
            {cell.getValue() || "Click to add transformation rule..."}
          </span>
        </div>
      );
    }

    if (columnDef.editType === "checkbox") {
      return (
        <input
          type="checkbox"
          disabled={!canUpdate}
          checked={cell.getValue() === "Y"}
          onChange={(e) =>
            updateCheckboxValue(row, cell.column.id, e.target.checked)
          }
          style={{
            width: "16px",
            height: "16px",
            cursor: canUpdate ? "pointer" : "not-allowed",
            margin: "auto",
            display: "block",
          }}
        />
      );
    } else if (columnDef.editType === "text") {
      return (
        <input
          type="text"
          disabled={!canUpdate}
          value={
            localValue[`${row.index}-${cell.column.id}`] ??
            cell.getValue() ??
            ""
          }
          onChange={(e) =>
            setLocalValue((prev) => ({
              ...prev,
              [`${row.index}-${cell.column.id}`]: e.target.value,
            }))
          }
          onBlur={(e) => updateRow(row, cell.column.id, e.target.value)}
          style={{
            width: "100%",
            padding: "1px 2px",
            height: "24px",
            fontSize: "12px",
            border: "1px solid #ced4da",
          }}
        />
      );
    } else if (columnDef.editType === "dropdown") {
      return (
        <Select
          isDisabled={!canUpdate}
          value={
            cell.getValue() !== undefined
              ? {
                  value: cell.getValue(),
                  label: cell.getValue(),
                }
              : null
          }
          onChange={(selectedOption) =>
            updateRow(
              row,
              cell.column.id,
              selectedOption?.value,
              columnDef.fieldName
            )
          }
          options={
            columnDef.fieldName === "STN"
              ? dropdownOptions?.map((opt) => ({
                  value: opt,
                  label: opt,
                })) || []
              : columnDef.fieldName === "SFN"
              ? dependentValues[row.original[sourceTableColumnName]]?.map(
                  (opt) => ({
                    value: opt.columnName,
                    label: opt.columnName,
                  })
                ) || []
              : []
          }
          isClearable={true} // Add this line
          isSearchable
          placeholder="Select"
          menuPortalTarget={document.body}
          styles={{
  menuPortal: (base) => ({ ...base, zIndex: 9999 }), // ✅ CHANGE THIS - was 2 or 2, now 9999
            menu: (provided) => ({
              ...provided,
              minWidth: "150px",
              width: "max-content",
            }),
            control: (provided) => ({
              ...provided,
              width: "100%",
              minHeight: "24px",
              height: "24px",
              fontSize: "12px",
            }),
            valueContainer: (provided) => ({
              ...provided,
              height: "24px",
              padding: "0 4px",
            }),
            input: (provided) => ({
              ...provided,
              margin: "0px",
              padding: "0px",
            }),
            singleValue: (provided) => ({
              ...provided,
              fontSize: "12px",
            }),
            indicatorsContainer: (provided) => ({
              ...provided,
              height: "24px",
            }),
            dropdownIndicator: (provided) => ({
              ...provided,
              padding: "2px",
            }),
            clearIndicator: (provided) => ({
              ...provided,
              padding: "2px",
            }),
            option: (provided) => ({
              ...provided,
              fontSize: "12px",
              padding: "4px 8px",
              whiteSpace: "nowrap",
            }),
          }}
        />
      );
    } else {
      return flexRender(cell.column.columnDef.cell, cell.getContext());
    }
  };

  const getFrozenColumnLeftPosition = (columnId) => {
    const headerGroups = table.getHeaderGroups();
    let position = 0;

    for (const headerGroup of headerGroups) {
      for (const header of headerGroup.headers) {
        if (header.id === columnId) break;
        if (frozenColumns.has(header.id)) {
          position += columnSizes[header.id] || header.column.getSize();
        }
      }
      break;
    }
    return position;
  };
  const getFrozenColumnStyle = (
    columnId,
    isHeader = false,
    isPinnedRow = false
  ) => {
    const isFrozen = frozenColumns.has(columnId);
    const baseStyle = {
      position: isFrozen || isHeader ? "sticky" : "relative",
      left: isFrozen ? `${getFrozenColumnLeftPosition(columnId)}px` : "auto",
      top: isHeader ? "0" : "auto", // Keep header sticky at top
      zIndex: isFrozen
        ? isHeader
          ? 15
          : isPinnedRow
          ? 12
          : 10
        : isHeader
        ? 5
        : isPinnedRow
        ? 3
        : 1,
      backgroundColor: isFrozen
        ? isHeader
          ? "#e8f4f8"
          : isPinnedRow
          ? "#e3f2fd"
          : "#f8fcff"
        : isHeader
        ? "#f4f4f4"
        : isPinnedRow
        ? "#e3f2fd"
        : "inherit",
      borderRight: isFrozen ? "2px solid #2196f3" : "1px solid #dee2e6",
      boxShadow: isFrozen ? "2px 0 5px rgba(0,0,0,0.1)" : "none",
    };
    return baseStyle;
  };

  const typeOfColumns = ["Source", "Target", "Transformation"];
  return (
    <div
      className="d-flex"
      style={{
        height: "calc(100vh - 130px)",
        overflow: "hidden",
        width: "100%",
        display: "flex",
        flexDirection: "row",
      }}
      ref={containerRef}
    >
      {/* Main Table Section - Takes remaining space */}
      <div
        className="d-flex flex-column"
        style={{
          flex: 1,
          minWidth: 0,
          transition:
            "width 0.3s cubic-bezier(0.4, 0, 0.2, 1), max-width 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
          overflow: "hidden",
          width:
            showAIAgent || showReverseEngineering
              ? `calc(100% - ${panelWidth}px)`
              : "100%",
          maxWidth:
            showAIAgent || showReverseEngineering
              ? `calc(100% - ${panelWidth}px)`
              : "100%",
        }}
      >
        {/* All existing table content goes here */}
        {loading && <Spinner />}
        <div
          className="flex-grow-1 d-flex flex-column"
          style={{ minHeight: 0, overflow: "hidden" }}
        >
          {/* Search & Controls Bar - TWO ROW LAYOUT */}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: "10px",

              padding: "8px 10px",
              backgroundColor: "#fafafa",
              borderBottom: "1px solid #e0e0e0",
              flexShrink: 0,
              zIndex: 10, // ⭐ ENSURE ICONS ARE VISIBLE
            }}
          >
            {/* ROW 1: Search + File Dropdown */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              {/* Global Search */}
              <input
                type="text"
                placeholder="Global Search..."
                value={globalFilter}
                onChange={(e) => setGlobalFilter(e.target.value)}
                style={{
                  padding: "4px 8px",
                  width: "200px",
                  height: "28px",
                  flexShrink: 0,
                }}
              />

              {/* File Dropdown */}
              <Select
                value={dropdownValue}
                onChange={setDropdownValue}
                options={uploadedFileList}
                isSearchable
                placeholder="Select a file"
                menuPortalTarget={document.body}
                styles={{
                  ...customSelectStyles,
                  control: (provided) => ({
                    ...provided,
                    width: "300px",
                    minHeight: "28px",
                    height: "28px",
                    flexShrink: 0,
                  }),
                  menu: (provided) => ({ ...provided, maxHeight: "200px" }),
                  menuList: (provided) => ({
                    ...provided,
                    maxHeight: "200px",
                    overflowY: "auto",
                  }),
                }}
              />
            </div>

            {/* ROW 2: Visibility Controls + Toggles + Icons */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                flexWrap: "wrap",
              }}
            >
              {/* Hide Columns Dropdown */}
              <div
                ref={visibilityButtonRef}
                style={{ position: "relative", flexShrink: 0 }}
              >
                <button
                  onClick={toggleColumnVisibilityMenu}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    padding: "2px 12px 2px 8px",
                    backgroundColor: "#fff",
                    border: "1px solid #bdbdbd",
                    borderRadius: "4px",
                    cursor: "pointer",
                    height: "28px",
                    fontSize: "13px",
                    minWidth: "120px",
                    boxShadow: columnVisibilityMenu
                      ? "0 2px 8px rgba(0,0,0,0.08)"
                      : "none",
                    transition: "border-color 0.2s, box-shadow 0.2s",
                  }}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.borderColor = "#2196f3")
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.borderColor = columnVisibilityMenu
                      ? "#2196f3"
                      : "#bdbdbd")
                  }
                >
                  <span style={{ flex: 1, textAlign: "left" }}>
                    Hide Columns
                  </span>
                  <ChevronDown size={14} />
                </button>

                {columnVisibilityMenu && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      right: 0,
                      width: "200px",
                      backgroundColor: "white",
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                      boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                      zIndex: 9999,
                      padding: "10px",
                      maxHeight: "300px",
                      overflowY: "auto",
                      marginTop: "2px",
                    }}
                  >
                    {/* Select/Unselect All Button */}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        marginBottom: "10px",
                        borderBottom: "1px solid #eee",
                        paddingBottom: "8px",
                      }}
                    >
                      {areAllColumnsSelected() ? (
                        <button
                          onClick={unselectAllColumns}
                          style={{
                            padding: "2px 8px",
                            backgroundColor: "#f0f0f0",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            cursor: "pointer",
                            fontSize: "11px",
                            width: "100%",
                          }}
                        >
                          Unselect All
                        </button>
                      ) : (
                        <button
                          onClick={selectAllColumns}
                          style={{
                            padding: "2px 8px",
                            backgroundColor: "#f0f0f0",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            cursor: "pointer",
                            fontSize: "11px",
                            width: "100%",
                          }}
                        >
                          Select All
                        </button>
                      )}
                    </div>

                    {/* Column List */}
                    {table
                      .getAllLeafColumns()
                      .filter(
                        (column) =>
                          ![
                            "usermappingfiledetailsid",
                            "usermappingfileid",
                            "templateid",
                            "isactive",
                          ].includes(column.id)
                      )
                      .map((column) => (
                        <div
                          key={column.id}
                          style={{
                            margin: "4px 0",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <input
                            type="checkbox"
                            checked={column.getIsVisible()}
                            onChange={column.getToggleVisibilityHandler()}
                            id={`col-${column.id}`}
                          />
                          <label
                            htmlFor={`col-${column.id}`}
                            style={{
                              marginLeft: "8px",
                              cursor: "pointer",
                              userSelect: "none",
                              fontSize: "12px",
                            }}
                          >
                            {column.id}
                          </label>
                        </div>
                      ))}
                  </div>
                )}
              </div>

              {/* Hide Groups Dropdown */}
              <div
                ref={dropdownRef}
                style={{ position: "relative", flexShrink: 0 }}
              >
                <button
                  type="button"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    padding: "2px 12px 2px 8px",
                    backgroundColor: "#fff",
                    border: showGroupDropdown
                      ? "1px solid #2196f3"
                      : "1px solid #bdbdbd",
                    borderRadius: "4px",
                    cursor: "pointer",
                    height: "28px",
                    fontSize: "13px",
                    minWidth: "120px",
                    boxShadow: showGroupDropdown
                      ? "0 2px 8px rgba(0,0,0,0.08)"
                      : "none",
                    transition: "border-color 0.2s, box-shadow 0.2s",
                  }}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.borderColor = "#2196f3")
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.borderColor = showGroupDropdown
                      ? "#2196f3"
                      : "#bdbdbd")
                  }
                  onClick={() => setShowGroupDropdown((prev) => !prev)}
                >
                  <span style={{ flex: 1, textAlign: "left" }}>
                    Hide Groups
                  </span>
                  <ChevronDown size={14} />
                </button>
                {showGroupDropdown && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      right: 0,
                      width: "200px",
                      backgroundColor: "white",
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                      boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                      zIndex: 9999,
                      padding: "10px 5px",
                      maxHeight: "300px",
                      overflowY: "auto",
                      marginTop: "2px",
                    }}
                  >
                    {typeOfColumns.map((column) => {
                      const lower = column.toLowerCase();
                      return (
                        <div
                          className="hide-columns-container"
                          key={column}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            margin: "6px 0",
                          }}
                        >
                          <input
                            type="checkbox"
                            id={`group-${column}`}
                            name={column}
                            className="checkox-style"
                            checked={hideColumnsData.includes(lower)}
                            onChange={() => handleHideColumnsData(lower)}
                            style={{ marginRight: 6 }}
                          />
                          <label
                            htmlFor={`group-${column}`}
                            className="ml-1 text-xs"
                            style={{ fontSize: 12, cursor: "pointer" }}
                          >
                            {column} Columns
                          </label>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>

              {/* Show inscope fields toggle */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  flexShrink: 0,
                }}
              >
                <input
                  type="checkbox"
                  id="show-inscope-toggle"
                  checked={showInscopeOnly}
                  onChange={() => setShowInscopeOnly((prev) => !prev)}
                  style={{ width: "16px", height: "16px", cursor: "pointer" }}
                />
                <label
                  htmlFor="show-inscope-toggle"
                  style={{
                    fontSize: "12px",
                    cursor: "pointer",
                    userSelect: "none",
                  }}
                >
                  Inscope
                </label>
              </div>

              {/* Show mandatory fields toggle */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  flexShrink: 0,
                }}
              >
                <input
                  type="checkbox"
                  id="show-mandatory-toggle"
                  checked={showMandatoryOnly}
                  onChange={() => setShowMandatoryOnly((prev) => !prev)}
                  style={{ width: "16px", height: "16px", cursor: "pointer" }}
                />
                <label
                  htmlFor="show-mandatory-toggle"
                  style={{
                    fontSize: "12px",
                    cursor: "pointer",
                    userSelect: "none",
                  }}
                >
                  Mandatory
                </label>
              </div>

              {/* SPACER - Push icons to right */}
              <div style={{ flex: 1 }}></div>

              {/* Icons Container - NOW VISIBLE */}
             {/* Icons Container - NOW VISIBLE */}
<div
  style={{
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flexShrink: 0,
    zIndex: 11,
  }}
>
  {/* AI Agent Icon */}
  <div
    title={
      showAIAgent
        ? "Close Mapping Assistant"
        : "Mapping Assistant"
    }
    onClick={() => {
      setShowAIAgent(!showAIAgent);
      setActivePanel(showAIAgent ? null : "ai");
      if (!showAIAgent) setShowReverseEngineering(false);
    }}
    style={{
      cursor: "pointer",
      padding: "6px 8px",
      borderRadius: "4px",
      transition: "all 0.2s ease",
      backgroundColor: showAIAgent ? "#e3f2fd" : "transparent",
      border: showAIAgent
        ? "1px solid #2196f3"
        : "1px solid transparent",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
    }}
    onMouseOver={(e) => {
      if (!showAIAgent)
        e.currentTarget.style.backgroundColor = "#f0f0f0";
    }}
    onMouseOut={(e) => {
      if (!showAIAgent)
        e.currentTarget.style.backgroundColor = "transparent";
    }}
  >
    <img
      src={chatbot}
      style={{ height: "20px" }}
      color={showAIAgent ? "#2196f3" : "#666"}
    />
  </div>
  

  {/* ERD Icon - NEW */}
  <div
    title={
      showReverseEngineering
        ? "Close ERD"
        : "Mapping Graph"
    }
    onClick={() => {
      setShowReverseEngineering(!showReverseEngineering);
      setActivePanel(showReverseEngineering ? null : "erd");
      if (!showReverseEngineering) setShowAIAgent(false);
    }}
    style={{
      cursor: "pointer",
      padding: "6px 8px",
      borderRadius: "4px",
      transition: "all 0.2s ease",
      backgroundColor: showReverseEngineering
        ? "#e3f2fd"
        : "transparent",
      border: showReverseEngineering
        ? "1px solid #2196f3"
        : "1px solid transparent",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
    }}
    onMouseOver={(e) => {
      if (!showReverseEngineering)
        e.currentTarget.style.backgroundColor = "#f0f0f0";
    }}
    onMouseOut={(e) => {
      if (!showReverseEngineering)
        e.currentTarget.style.backgroundColor = "transparent";
    }}
  >
    <img
      src={network}
      style={{ height: "25px" }}
      color={showAIAgent ? "#2196f3" : "#666"}
    />
  </div>
  
  {/* History Icon */}
  <div
    title="View History"
    onClick={() => navigate(`/history-data/${pageData.fileID}`)}
    style={{
      cursor: "pointer",
      padding: "6px 8px",
      borderRadius: "4px",
      transition: "all 0.2s ease",
      display: "flex",
      alignItems: "center",
      flexShrink: 0,
    }}
    onMouseOver={(e) =>
      (e.currentTarget.style.backgroundColor = "#f0f0f0")
    }
    onMouseOut={(e) =>
      (e.currentTarget.style.backgroundColor = "transparent")
    }
  >
    <img
      src={history}
      style={{ height: "25px" }}
      color={showAIAgent ? "#2196f3" : "#666"}
    />
  </div>
  
  {/* Export CSV Icon */}
  <div
    title="Export as CSV"
    onClick={() =>
      fetchMappingDataByExcelID(pageData.fileID, true)
    }
    style={{
      cursor: "pointer",
      padding: "6px 8px",
      borderRadius: "4px",
      transition: "all 0.2s ease",
      display: "flex",
      alignItems: "center",
      flexShrink: 0,
    }}
    onMouseOver={(e) =>
      (e.currentTarget.style.backgroundColor = "#f0f0f0")
    }
    onMouseOut={(e) =>
      (e.currentTarget.style.backgroundColor = "transparent")
    }
  >
     <img
      src={download}
      style={{ height: "25px" }}
      color={showAIAgent ? "#2196f3" : "#666"}
    />
  </div>
</div> {/* ✅ This closes Icons Container */}
            </div>
          </div>

          {/* Table Container */}
          {data.length > 0 && (
            <div
              style={{
                overflowX: "auto",
                width: "100%",
                maxWidth: "100%",
                height: calculateTableHeight(pagination),
                flex: "1 1 auto",
                border: "1px solid #dee2e6",
              }}
            >
              <table
                style={{
                  width: "max-content",
                  borderCollapse: "collapse",
                  border: "1px solid #dee2e6",
                  position: "relative",
                }}
              >
                {/* Table Header */}
                <thead
                  style={{
                    position: "sticky",
                    top: 0,
                    background: "#f4f4f4",
                    zIndex: 1,
                    boxShadow: "0 2px 3px rgba(0,0,0,0.1)",
                  }}
                >
                  {table.getHeaderGroups().map((headerGroup) => (
                    <tr
                      key={headerGroup.id}
                      style={{
                        background: "#f4f4f4",
                        borderBottom: "1px solid #dee2e6",
                        height: "36px",
                      }}
                    >
                      {headerGroup.headers.map((header) => {
                        // if (
                        //   dropdownValue?.id === 2 &&
                        //   (header?.id.toLowerCase().includes("scope") ||
                        //     header?.id.toLowerCase().includes("mandatory"))
                        // ) {
                        //   return null;
                        // }
                        const columnDef = header.column.columnDef;
                        if (
                          hideColumnsData.includes(
                            columnDef?.columncategoryname?.toLowerCase()
                          )
                        ) {
                          return null;
                        }
                        return (
                          <th
                            key={header.id}
                            onClick={header.column.getToggleSortingHandler()}
                            style={{
                              ...getFrozenColumnStyle(header.id, true, false),
                              padding: "2px 4px",
                              border: "1px solid #dee2e6",
                              cursor: "pointer",
                              position: frozenColumns.has(header.id)
                                ? "sticky"
                                : "relative",
                              left: frozenColumns.has(header.id)
                                ? `${getFrozenColumnLeftPosition(header.id)}px`
                                : undefined,
                              zIndex: frozenColumns.has(header.id) ? 15 : 5,
                              backgroundColor: frozenColumns.has(header.id)
                                ? "#e8f4f8"
                                : "#f4f4f4",
                              width:
                                columnSizes[header.id] ||
                                header.column.getSize(),
                              minWidth: "50px",
                              fontSize: "12px",
                              fontWeight: "600",
                              textAlign: "left",
                              height: "36px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              boxShadow: frozenColumns.has(header.id)
                                ? "2px 0 5px rgba(0,0,0,0.1)"
                                : "none",
                              borderRight: frozenColumns.has(header.id)
                                ? "2px solid #2196f3"
                                : "1px solid #dee2e6",
                            }}
                          >
                            <span
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                              }}
                            >
                              <span
                                onClick={(e) => {
                                  e.stopPropagation();
                                  toggleColumnFreeze(header.id);
                                }}
                                style={{
                                  width: "16px",
                                  height: "16px",
                                  backgroundColor: frozenColumns.has(header.id)
                                    ? "#2196f3"
                                    : "#ccc",
                                  color: "white",
                                  fontSize: "10px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  cursor: "pointer",
                                  borderRadius: "2px",
                                  zIndex: 10,
                                }}
                                title={
                                  frozenColumns.has(header.id)
                                    ? "Unfreeze column"
                                    : "Freeze column"
                                }
                              >
                                📌
                              </span>
                              <span>
                                {flexRender(
                                  header.column.columnDef.header,
                                  header.getContext()
                                )}
                                {header.column.getIsSorted() === "asc"
                                  ? " 🔼"
                                  : header.column.getIsSorted() === "desc"
                                  ? " 🔽"
                                  : ""}
                              </span>
                            </span>
                            {/* Resizer */}
                            <div
                              onMouseDown={(e) =>
                                handleColumnResizeStart(e, header)
                              }
                              style={{
                                position: "absolute",
                                right: 0,
                                top: 0,
                                height: "100%",
                                width: "5px",
                                background:
                                  resizingColumn === header.id
                                    ? "#2196f3"
                                    : "transparent",
                                cursor: "col-resize",
                                userSelect: "none",
                                touchAction: "none",
                              }}
                            />
                          </th>
                        );
                      })}
                    </tr>
                  ))}
                </thead>

                {/* Table Body */}
                <tbody>
                  {table.getTopRows().map((row) => {
                    // if (
                    //   showInscopeOnly &&
                    //   !(
                    //     row.original.inscope === "Y" ||
                    //     row.original["In-scope"] === "Y"
                    //   )
                    // ) {
                    //   return null;
                    // }
                    // if (
                    //   showMandatoryOnly &&
                    //   !(
                    //     row.original.mandatoryfeild === "Y" ||
                    //     row.original["Mandatory Field (S4)"] === "Y"
                    //   )
                    // ) {
                    //   return null;
                    // }
                    return (
                      <tr
                        key={row.id}
                        style={{
                          borderBottom: "1px solid #dee2e6",
                          height: rowSizes[row.id] || "36px",
                          backgroundColor: "#e3f2fd",
                          position: "sticky",
                          top: "36px", // Position below header
                          zIndex: 5, // Higher than regular rows but lower than header
                        }}
                      >
                        {row.getVisibleCells().map((cell) => {
                          const columnDef = cell.column.columnDef;
                          if (
                            hideColumnsData.includes(
                              columnDef?.columncategoryname?.toLowerCase()
                            )
                          ) {
                            return null;
                          }
                          return (
                            <td
                              key={cell.id}
                              style={{
                                ...getFrozenColumnStyle(
                                  cell.column.id,
                                  false,
                                  true
                                ), // Pass isPinnedRow as true
                                padding: "2px 4px",
                                border: "1px solid #dee2e6",
                                width:
                                  columnSizes[cell.column.id] ||
                                  cell.column.getSize(),
                                maxWidth:
                                  columnSizes[cell.column.id] ||
                                  cell.column.getSize(),
                                fontSize: "12px",
                                height: rowSizes[row.id] || "36px",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                position: "relative",
                              }}
                            >
                              {columnDef.editType === "checkbox" ? (
                                <input
                                  type="checkbox"
                                  disabled={!canUpdate}
                                  checked={cell.getValue() === "Y"}
                                  onChange={(e) =>
                                    updateCheckboxValue(
                                      row,
                                      cell.column.id,
                                      e.target.checked
                                    )
                                  }
                                  style={{
                                    width: "16px",
                                    height: "16px",
                                    cursor: canUpdate
                                      ? "pointer"
                                      : "not-allowed",
                                    margin: "auto",
                                    display: "block",
                                  }}
                                />
                              ) : columnDef.editType === "text" ? (
                                <input
                                  type="text"
                                  disabled={!canUpdate}
                                  value={
                                    localValue[
                                      `${row.index}-${cell.column.id}`
                                    ] ??
                                    cell.getValue() ??
                                    ""
                                  }
                                  onChange={(e) =>
                                    setLocalValue((prev) => ({
                                      ...prev,
                                      [`${row.index}-${cell.column.id}`]:
                                        e.target.value,
                                    }))
                                  }
                                  onBlur={(e) =>
                                    updateRow(
                                      row,
                                      cell.column.id,
                                      e.target.value
                                    )
                                  }
                                  style={{
                                    width: "100%",
                                    padding: "1px 2px",
                                    height: "24px",
                                    fontSize: "12px",
                                    border: "1px solid #ced4da",
                                  }}
                                />
                              ) : columnDef.editType === "dropdown" ? (
                                <Select
                                  isDisabled={!canUpdate}
                                  value={
                                    cell.getValue() !== undefined
                                      ? {
                                          value: cell.getValue(),
                                          label: cell.getValue(),
                                        }
                                      : null
                                  }
                                  onChange={(selectedOption) =>
                                    updateRow(
                                      row,
                                      cell.column.id,
                                      selectedOption?.value,
                                      columnDef.fieldName
                                    )
                                  }
                                  options={
                                    columnDef.fieldName === "STN"
                                      ? dropdownOptions?.map((opt) => ({
                                          value: opt,
                                          label: opt,
                                        })) || []
                                      : columnDef.fieldName === "SFN"
                                      ? dependentValues[
                                          row.original[sourceTableColumnName]
                                        ]?.map((opt) => ({
                                          value: opt.columnName,
                                          label: opt.columnName,
                                        })) || []
                                      : []
                                  }
                                  isClearable={true}
                                  isSearchable
                                  placeholder="Select"
                                  menuPortalTarget={document.body}
                                  styles={{
                                    menuPortal: (base) => ({
                                      ...base,
                                      zIndex: 9999,
                                    }),
                                    menu: (provided) => ({
                                      ...provided,
                                      minWidth: "250px", // Add this line
                                      width: "max-content", // Add this line
                                    }),
                                    control: (provided) => ({
                                      ...provided,
                                      width: "100%",
                                      minHeight: "24px",
                                      height: "24px",
                                      fontSize: "12px",
                                    }),
                                    valueContainer: (provided) => ({
                                      ...provided,
                                      height: "24px",
                                      padding: "0 4px",
                                    }),
                                    input: (provided) => ({
                                      ...provided,
                                      margin: "0px",
                                      padding: "0px",
                                    }),
                                    singleValue: (provided) => ({
                                      ...provided,
                                      fontSize: "12px",
                                    }),
                                    indicatorsContainer: (provided) => ({
                                      ...provided,
                                      height: "24px",
                                    }),
                                    dropdownIndicator: (provided) => ({
                                      ...provided,
                                      padding: "2px",
                                    }),
                                    clearIndicator: (provided) => ({
                                      ...provided,
                                      padding: "2px",
                                    }),
                                    option: (provided) => ({
                                      ...provided,
                                      fontSize: "12px",
                                      padding: "4px 8px",
                                      whiteSpace: "nowrap",
                                    }),
                                  }}
                                />
                              ) : (
                                flexRender(
                                  cell.column.columnDef.cell,
                                  cell.getContext()
                                )
                              )}
                            </td>
                          );
                        })}
                        <td
                          style={{
                            position: "absolute",
                            bottom: 0,
                            left: 0,
                            right: 0,
                            height: "5px",
                            background:
                              resizingRow === row.id
                                ? "#2196f3"
                                : "transparent",
                            cursor: "row-resize",
                            userSelect: "none",
                            touchAction: "none",
                            zIndex: 2,
                          }}
                          onMouseDown={(e) => handleRowResizeStart(e, row.id)}
                        />
                      </tr>
                    );
                  })}
                  {table.getRowModel().rows.map((row) => {
                    // Filter for inscope if toggle is ON
                    // if (
                    //   showInscopeOnly &&
                    //   !(
                    //     row.original.inscope === "Y" ||
                    //     row.original["In-scope"] === "Y"
                    //   )
                    // ) {
                    //   return null;
                    // }
                    // if (
                    //   showMandatoryOnly &&
                    //   !(
                    //     row.original.mandatoryfeild === "Y" ||
                    //     row.original["Mandatory Field (S4)"] === "Y"
                    //   )
                    // ) {
                    //   return null;
                    // }
                    return (
                      <tr
                        key={row.id}
                        style={{
                          borderBottom: "1px solid #dee2e6",
                          height: rowSizes[row.id] || "36px",
                          backgroundColor: row.getIsSelected()
                            ? "#f5f5f5"
                            : "white",
                          position: "relative",
                        }}
                      >
                        {row.getVisibleCells().map((cell) => {
                          const columnDef = cell.column.columnDef;
                          return (
                            <td
                              key={cell.id}
                              style={{
                                ...getFrozenColumnStyle(
                                  cell.column.id,
                                  false,
                                  false
                                ), // Pass isPinnedRow as false
                                padding: "2px 4px",
                                border: "1px solid #dee2e6",
                                width:
                                  columnSizes[cell.column.id] ||
                                  cell.column.getSize(),
                                maxWidth:
                                  columnSizes[cell.column.id] ||
                                  cell.column.getSize(),
                                fontSize: "12px",
                                height: rowSizes[row.id] || "36px",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {renderCellContent(cell, row, columnDef)}
                            </td>
                          );
                        })}
                        <td
                          style={{
                            position: "absolute",
                            bottom: 0,
                            left: 0,
                            right: 0,
                            height: "5px",
                            background:
                              resizingRow === row.id
                                ? "#2196f3"
                                : "transparent",
                            cursor: "row-resize",
                            userSelect: "none",
                            touchAction: "none",
                            zIndex: 2,
                          }}
                          onMouseDown={(e) => handleRowResizeStart(e, row.id)}
                        />
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}

          {/* Pagination Controls */}
          {data.length > 0 && (
            <div
              style={{
                borderTop: "1px solid #dee2e6",
                padding: "5px 0",
                backgroundColor: "#f8f9fa",
                fontSize: "12px",
              }}
            >
              <nav>
                <ul className="pagination justify-content-center align-items-center m-0">
                  <li
                    className={`page-item ${
                      !table.getCanPreviousPage() && "disabled"
                    }`}
                  >
                    <button
                      onClick={() => table.setPageIndex(0)}
                      className="page-link py-1 px-2"
                    >
                      ⏮ First
                    </button>
                  </li>
                  <li
                    className={`page-item ${
                      !table.getCanPreviousPage() && "disabled"
                    }`}
                  >
                    <button
                      onClick={() => table.previousPage()}
                      className="page-link py-1 px-2"
                    >
                      ◀ Prev
                    </button>
                  </li>

                  {/* Page Dropdown */}
                  <li className="page-item active">
                    <span className="page-link d-flex align-items-center py-1 px-2">
                      Page&nbsp;
                      <select
                        className="form-select form-select-sm mx-1"
                        style={{
                          width: "65px",
                          height: "24px",
                          fontSize: "12px",
                        }}
                        value={pagination.pageIndex}
                        onChange={(e) =>
                          table.setPageIndex(Number(e.target.value))
                        }
                      >
                        {Array.from(
                          { length: table.getPageCount() },
                          (_, index) => (
                            <option key={index} value={index}>
                              {index + 1}
                            </option>
                          )
                        )}
                      </select>
                      of {table.getPageCount()}
                    </span>
                  </li>

                  <li
                    className={`page-item ${
                      !table.getCanNextPage() && "disabled"
                    }`}
                  >
                    <button
                      onClick={() => table.nextPage()}
                      className="page-link"
                      style={{ paddingTop: "4px", paddingBottom: "4px" }}
                    >
                      Next ▶
                    </button>
                  </li>
                  <li
                    className={`page-item ${
                      !table.getCanNextPage() && "disabled"
                    }`}
                  >
                    <button
                      onClick={() =>
                        table.setPageIndex(table.getPageCount() - 1)
                      }
                      className="page-link"
                      style={{ paddingTop: "4px", paddingBottom: "4px" }}
                    >
                      ⏭ Last
                    </button>
                  </li>

                  {/* Rows per page */}
                  <li className="ms-3 d-flex align-items-center">
                    <label className="me-2 mb-0">Rows per page:</label>
                    <select
                      className="form-select form-select-sm"
                      style={{ width: "70px" }}
                      value={pagination.pageSize}
                      onChange={handlePageSizeChange}
                    >
                      {[15, 20, 25, 50].map((size) => (
                        <option key={size} value={size}>
                          {size}
                        </option>
                      ))}
                    </select>
                  </li>
                </ul>
              </nav>
            </div>
          )}
        </div>
      </div>

      <div
        ref={panelRef}
        style={{
          width: showAIAgent ? `${panelWidth}px` : "0px",
          minWidth: showAIAgent ? `${panelWidth}px` : "0px",
          maxWidth: showAIAgent ? `${panelWidth}px` : "0px",
          height: "calc(100vh - 180px)",
          overflow: "hidden",
          transition: showAIAgent
            ? "none"
            : "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
          borderLeft: showAIAgent ? "1px solid #e0e0e0" : "none",
          backgroundColor: "#fff",
          display: "flex",
          flexDirection: "column",
          boxShadow: showAIAgent ? "-2px 0 8px rgba(0,0,0,0.1)" : "none",
          zIndex: 1000,
          flexShrink: 0,
          position: "relative",
        }}
      >
        {/* Resizer Handle - Left edge of panel */}
        {showAIAgent && (
          <div
            ref={resizerRef}
            onMouseDown={() => setIsResizingPanel(true)}
            style={{
              position: "absolute",
              left: 0,
              top: 0,
              width: "8px",
              height: "100%",
              cursor: "col-resize",
              backgroundColor: "transparent",
              transition: "background-color 0.2s",
              zIndex: 1001,
              userSelect: "none",
              touchAction: "none",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#2196f3";
            }}
            onMouseLeave={(e) => {
              if (!isResizingPanel) {
                e.currentTarget.style.backgroundColor = "transparent";
              }
            }}
            title="Drag to resize panel"
          />
        )}

        {showAIAgent && (
          <>
            {/* Chatbot Header */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "12px 16px",
                borderBottom: "1px solid #e0e0e0",
                backgroundColor: "#f8f9fa",
                flexShrink: 0,
                height: "52px",
                paddingLeft: "20px", // Add left padding to account for resizer
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <div className="flex items-center gap-2">
                  <img
                    src={logo}
                    alt="Falcon AI Logo"
                    className="w-6 h-6 rounded-full object-cover cursor-pointer"
                  />
                </div>
                <h3
                  style={{
                    margin: 0,
                    fontSize: "15px",
                    fontWeight: 600,
                    color: "#333",
                  }}
                >
                  BlueGecko AI
                </h3>
                {/* <span
            style={{
              fontSize: "11px",
              color: "#999",
              marginLeft: "8px",
            }}
          >
            ({panelWidth}px)
          </span> */}
              </div>
              <button
                onClick={() => {
                  setShowAIAgent(false);
                  setActivePanel(null); // Add this line
                }}
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  padding: "4px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "4px",
                  transition: "background-color 0.2s",
                  color: "#666",
                }}
                onMouseOver={(e) =>
                  (e.currentTarget.style.backgroundColor = "#e8e8e8")
                }
                onMouseOut={(e) =>
                  (e.currentTarget.style.backgroundColor = "transparent")
                }
                title="Close BlueGecko AI"
              >
                <X size={18} />
              </button>
            </div>

            {/* Chatbot Content - Full height with proper scrolling */}
            <div
              style={{
                flex: 1,
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
                minHeight: 0,
                paddingLeft: "8px", // Add padding to prevent content touching resizer
              }}
            >
              <FalconAIChatbot fileId={pageData.fileID} />
            </div>
          </>
        )}
      </div>

      {/* Reverse Engineering Panel - NEW */}
      <div
        style={{
          width: showReverseEngineering ? `${panelWidth}px` : "0px",
          minWidth: showReverseEngineering ? `${panelWidth}px` : "0px",
          maxWidth: showReverseEngineering ? `${panelWidth}px` : "0px",
          height: "calc(100vh - 180px)",
          overflow: "hidden",
          transition: showReverseEngineering
            ? "none"
            : "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
          borderLeft: showReverseEngineering ? "1px solid #e0e0e0" : "none",
          backgroundColor: "#fff",
          display: "flex",
          flexDirection: "column",
          boxShadow: showReverseEngineering
            ? "-2px 0 8px rgba(0,0,0,0.1)"
            : "none",
          zIndex: 1000,
          flexShrink: 0,
          position: "relative",
        }}
      >
        {/* Resizer Handle */}
        {showReverseEngineering && (
          <div
            onMouseDown={() => setIsResizingPanel(true)}
            style={{
              position: "absolute",
              left: 0,
              top: 0,
              width: "8px",
              height: "100%",
              cursor: "col-resize",
              backgroundColor: "transparent",
              transition: "background-color 0.2s",
              zIndex: 1001,
              userSelect: "none",
              touchAction: "none",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#2196f3";
            }}
            onMouseLeave={(e) => {
              if (!isResizingPanel) {
                e.currentTarget.style.backgroundColor = "transparent";
              }
            }}
            title="Drag to resize panel"
          />
        )}

        {showReverseEngineering && (
          <>
            {/* ERD Header */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "12px 16px",
                borderBottom: "1px solid #e0e0e0",
                backgroundColor: "#f8f9fa",
                flexShrink: 0,
                height: "52px",
                paddingLeft: "20px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <Network size={20} color="#2196f3" />
                <h3
                  style={{
                    margin: 0,
                    fontSize: "15px",
                    fontWeight: 600,
                    color: "#333",
                  }}
                >
                  Mapping Graph
                </h3>
              </div>
              <button
                onClick={() => {
                  setShowReverseEngineering(false);
                  setActivePanel(null);
                }}
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  padding: "4px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "4px",
                  transition: "background-color 0.2s",
                  color: "#666",
                }}
                onMouseOver={(e) =>
                  (e.currentTarget.style.backgroundColor = "#e8e8e8")
                }
                onMouseOut={(e) =>
                  (e.currentTarget.style.backgroundColor = "transparent")
                }
                title="Close ERD"
              >
                <X size={18} />
              </button>
            </div>

            {/* ERD Content */}
            <div
              style={{
                flex: 1,
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
                minHeight: 0,
                paddingLeft: "8px",
              }}
            >
              <DataLineageViewers />
            </div>
          </>
        )}
      </div>
      <StickyNotesPopup
        isOpen={stickyNotePopup.isOpen}
        onClose={() =>
          setStickyNotePopup({
            isOpen: false,
            value: "",
            rowIndex: null,
            columnId: null,
            position: null,
          })
        }
        onSave={(value) => {
          if (stickyNotePopup.rowIndex !== null && stickyNotePopup.columnId) {
            const row = table.getRowModel().rows[stickyNotePopup.rowIndex];
            if (row) {
              updateRow(row, stickyNotePopup.columnId, value);
            }
          }
        }}
        initialValue={stickyNotePopup.value}
        position={stickyNotePopup.position} // <-- ADD THIS LINE
      />
    </div>
  );
};

export default CreateTable;
